import { BFFClient } from "services/client";
import { BFF_SUPPORT_TICKETS_NEW, BFF_SUPPORT_USER_STATUS } from "utils/urls";

async function createNewTicket(
  token: string,
  payload: any,
  param?: string
): Promise<any> {
  const ticket = await BFFClient(token).post(BFF_SUPPORT_TICKETS_NEW, payload, {
    params: {
      product: param,
    },
  });

  return ticket.data;
}

async function getSupportUserStatus(token: string) {
  const status = await BFFClient(token).get(BFF_SUPPORT_USER_STATUS);
  return status.data;
}

export const supportTicketsService = {
  createNewTicket,
  getSupportUserStatus,
};
